import { VStack, Container } from "@chakra-ui/react";

import { FC } from "react";
import Renderer from "src/lib/renderer";

import { BlockContainer } from "src/atoms";

import MobileAccordion from "./components/MobileAccordion";
import DesktopGrid from "./components/DesktopGrid";
import { heading4 } from "src/lib/renderer/elements/headings";
import { Element } from "@prismicio/react";

const BlockCreationRedirection: FC<
  Gatsby.PageBlockCreationRedirectionFragment
> = ({ primary, items }) => {
  if (!primary) throw Error();

  const { content } = primary;

  return (
    <BlockContainer>
      <VStack spacing={{ base: "space-24", md: "space-32" }}>
        <Container variant="heading">
          <VStack
            spacing="space-16"
            sx={{
              "h2, h3": {
                marginBottom: 0,
              },
              "h2, h3, h4, p": {
                color: "white",
              },
            }}
          >
            <Renderer field={content} overrides={{
              [Element.paragraph]: (args: any) =>
                heading4({
                  ...args,
                })
            }} />
          </VStack>
        </Container>

        <MobileAccordion items={items} />
        <DesktopGrid items={items} />
      </VStack>
    </BlockContainer>
  );
};

export default BlockCreationRedirection;
